import React, { useState, useEffect, useRef, useCallback } from "react";
import "./navstyle.css";
import myLogo from "../../images/shawn.gif";
import { linkData } from "./Navdata";
import { FaSortAmountDownAlt, FaSortAmountUpAlt } from "react-icons/fa";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [fixedClass, setFixedClass] = useState(null);
  const [heightOfNav, setHeightOfNav] = useState(null);
  const navHeight = useRef(null);
  const DivContainer = useRef(null);
  const UlContainer = useRef(null);
  const FaButtonOpenClick = () => {
    setIsOpen((previous) => !previous);
  };
  // this useEffect for the links height
  useEffect(() => {
    const UlHight = UlContainer.current.getBoundingClientRect().height + 30;

    if (isOpen) {
      DivContainer.current.style.height = `${UlHight}px`;
    } else {
      DivContainer.current.style.height = "0px";
    }
  }, [isOpen]);

  //this useEffect for fixed navbar
  const SettingClass = useCallback(() => {
    let windowHeight = window.scrollY;
    if (window !== undefined) {
      return windowHeight > heightOfNav
        ? setFixedClass("fixed-nav")
        : setFixedClass(null);
    }
  }, [heightOfNav]);
  useEffect(() => {
    const NavHeight = navHeight.current.getBoundingClientRect().height + 10;
    setHeightOfNav(NavHeight);
    window.addEventListener("scroll", SettingClass);
    return () => window.removeEventListener("scroll", SettingClass);
  }, [SettingClass]);

  
  // This for smooth scrool
  const LinkOnclick = (e) => {
    e.preventDefault();
    setIsOpen(false);
    const id = e.target.getAttribute("href");
    const location = document.querySelector(id);

    //vanila js approach :)
    const $my_navBar = document.querySelector("#nav");
    const main_link_container = document.querySelector(".right-nav-textHeader");
    const navHei = $my_navBar.getBoundingClientRect().height;
    const mainLinksContainer_height =
      main_link_container.getBoundingClientRect().height;
    const fixed_nav = $my_navBar.classList.contains("fixed-nav");
    let section_position = location.offsetTop - navHei;
    //Now checking if the nav bar is not fixed, then "subtract" more from the "section_position"
    if (!fixed_nav) {
      section_position = section_position - navHei;
    }
    if (navHei > 95) {
      section_position = section_position + mainLinksContainer_height;
    }
    //invoking window.scrollTo method
    window.scrollTo({
      left: 0,
      top: section_position,
    });
  };
  return (
    <>
      {/* // Navigation bar */}
      <nav id="nav" className={`${fixedClass}`} ref={navHeight}>
        <div className="nav-main-place">
          {/* Logo and toggleNav bar logo */}
          <div className="left-nav-logoHeader">
            <div className="image-sec">
              <img src={myLogo} alt="logo icon" className="naveLogo-img" />
              <h1>
                <span className="h">h</span>
                <span className="a">a</span>
                <span className="w">w</span>
                <span className="n">n</span>
              </h1>
            </div>
            <button onClick={FaButtonOpenClick} className="toggleNav">
              {isOpen ? <FaSortAmountUpAlt /> : <FaSortAmountDownAlt />}
            </button>
          </div>

          {/* links section */}

          <div className="right-nav-textHeader" ref={DivContainer}>
            <ul className="links" ref={UlContainer}>
              {linkData.map((link) => {
                const { id, url, text, icon } = link;
                return (
                  <li key={id}>
                    <a onClick={LinkOnclick} href={url} className="scroll-link">
                      {icon}
                      {text}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </nav>
      <script src="nav.js"></script>
    </>
  );
};
